// CUSTOMER MANAGEMENT

import { AccountIdParamValue, LoginSidParamValue } from "./accounts";
import {
  SocialTradingOfferIdParamValue,
  SocialTradingProviderIdParamValue,
  SocialTradingSubscriptionIdParamValue,
} from "./social-trading";

export const SIGNUP_API = "/api/v2/authentication/email-password/sign-up";
export const SIGN_IN_API = "/api/v1/authentication/sign-in";
export const REFRESH_TOKEN_API = "/api/v1/authentication/refresh-token";
export const LOGOUT_API = "/api/v1/authentication/logout";
export const CHANGE_PASSWORD_API = "/api/v2/authentication/reset-password";
export const SOCIAL_SIGN_IN_API = "/api/v1/authentication/social/sign-in";
export const SOCIAL_SIGNUP_API = "/api/v2/authentication/social/sign-up";
export const EMAIL_VERIFICATION_API =
  "/api/v1/authentication/email-verification";
export const PHONE_VERIFICATION_API =
  "/api/v1/authentication/phone-verification";
export const INITIATE_FORGOT_PASSWORD_API =
  "/api/v1/authentication/initiate-forgot-password";
export const FORGOT_PASSWORD_RESET_API =
  "/api/v2/authentication/forgot-password-reset";

export const SUBMIT_DOCUMENTS_API = "/api/v2/documents/submit";

export const SUBMIT_EMPLOYMENT_DETAILS_API = "/api/v1/employment/save";
export const UPDATE_EMPLOYMENT_DETAILS_API = "/api/v1/employment/update";
export const FETCH_EMPLOYMENT_DETAILS_API = "/api/v1/employment/user";

export const FETCH_FINANCIAL_DETAILS_API = "/api/v1/financial-details/user";
export const SUBMIT_FINANCIAL_DETAILS_API = "/api/v1/financial-details/create";
export const UPDATE_FINANCIAL_DETAILS_API = "/api/v1/financial-details/update";

export const FETCH_PERSONAL_DETAILS_API = "/api/v1/personal-details/fetch";
export const SUBMIT_PERSONAL_DETAILS_API = "/api/v1/personal-details/create";
export const UPDATE_PERSONAL_DETAILS_API = "/api/v1/personal-details/update";

export const COUNTRIES_API = "/api/v1/utility/countries";
export const INDUSTRIES_API = "/api/v1/utility/industries";
export const SEND_OTP_API = "api/v1/utility/otp";
export const VERIFY_OTP_API = "api/v1/utility/otp/verify";
export const FETCH_ACCOUNT_TYPES_API = "api/v2/utility/account-types";
export const FETCH_PLATFORM_SERVERS_API = "api/v1/utility/platform-servers";

export const ONBOARDING_STATUS_API = "/api/v1/onboarding/status";
export const ONBOARDING_VALIDATE_API = "/api/v1/onboarding/validate";
export const ONBOARDING_REGISTER_API = "/api/v1/onboarding/register";
export const FETCH_TRADING_EXPERIENCE_API =
  "/api/v1/onboarding/trading-experience";
export const SUBMIT_TRADING_EXPERIENCE_API =
  "/api/v1/onboarding/trading-experience";
export const UPDATE_TRADING_EXPERIENCE_API =
  "/api/v1/onboarding/trading-experience";

export const FETCH_TRADING_ACCOUNTS_API = "/api/v2/trading-accounts/fetch";
export const SUBMIT_TRADING_ACCOUNTS_API = "/api/v2/trading-accounts";
export const UPDATE_LEVERAGE_API = `/api/v1/trading-accounts/${AccountIdParamValue}/update-leverage`;
export const INITIATE_RESET_PASSWORD_API = `/api/v1/trading-accounts/${AccountIdParamValue}/reset-password/initiate`;
export const RESET_PASSWORD_API = "/api/v1/trading-accounts/reset-password";
export const FETCH_SWAP_FREE_DETAILS_API = `/api/v1/trading-accounts/${LoginSidParamValue}/swap-free`;
export const SUBMIT_SWAP_FREE_API = `/api/v1/trading-accounts/${LoginSidParamValue}/swap-free`;



export const FETCH_USER_API = "/api/v1/user";

export const FETCH_NEWS_API = "/api/v1/financial-news/forex";

export const FETCH_CONTACTS_API = "/api/v1/contacts";
export const SUBMIT_CONTACT_API = "/api/v1/contacts";

// CABINET INTEGRATION
export const FETCH_CLIENT_CABINET_ACCOUNT_COMMISSION_API =
  "/api/v1/client-cabinet/account-commission";
export const FETCH_CLIENT_CABINET_CLIENT_COMMISSION_API =
  "/api/v1/client-cabinet/client-commission";
export const FETCH_CLIENT_CABINET_COMMISSION_SETTINGS_API =
  "/api/v1/client-cabinet/commission-settings";
export const FETCH_CLIENT_CABINET_IB_COMMISSIONS_API =
  "/api/v1/client-cabinet/ib-commissions";
export const FETCH_CLIENT_CABINET_IB_PERFORMANCE_DASHBOARD_API =
  "/api/v1/client-cabinet/ib-performance-dashboard";
export const FETCH_CLIENT_CABINET_IB_REFERRALS_API =
  "/api/v1/client-cabinet/ib-referrals";
export const FETCH_CLIENT_CABINET_IB_TRANSACTIONS_API =
  "/api/v1/client-cabinet/ib-transactions";

// GOOGLE ANALYTICS
export const MONITORING_CLIENTS_API = "/api/v1/monitoring/clients";

// META ANALYTICS
export const MONITORING_META_CLIENTS_API = "/api/v1/monitoring/meta/clients";

// PAYMENT
export const FETCH_WALLET_API = "/api/v1/wallet/fetch";
export const INITIATE_STK_PUSH_API = "/api/v2/payment/initiate-stkpush";
export const FETCH_PAYMENT_TRANSACTION_API = "/api/v1/payments/transaction";
export const WITHDRAW_API = "/api/v3/payment/b2c/withdrawal";
export const FETCH_EXCHANGE_RATE_API = "/api/v1/utility/exchange-rate";
export const FETCH_TRANSACTIONS_API = "/api/v1/payment/transactions/fetch";
export const TRANSFERS_API = "/api/v1/payment/internal-transfer";
export const INITIATE_BANK_TRANSFER_API =
  "/api/v1/payment/bank-transfers/initiate";
export const INITIATE_MERCHANT_PAYMENT_API =
  "/api/v2/payment/merchant-payment-initiate";
export const INITIATE_CASHIA_WITHDRAWAL_API =
  "/api/v2/payment/cashia/merchant-withdrawals";

// INTERNAL BROKER
export const FETCH_INTRODUCING_BROKER_APPLICATION_API =
  "/api/v1/ib-application";
export const SUBMIT_INTRODUCING_BROKER_APPLICATION_API =
  "/api/v1/ib-application";
export const FETCH_REFERRAL_LINKS_API = "/api/v1/ib-application/referral-link";
export const SUBMIT_REFERRAL_LINK_API = "/api/v1/ib-application/referral-link";
export const CARD_PAYMENT_API = "/api/v1/payment/card";

// SOCIAL TRADING
export const SOCIAL_TRADING_PROVIDERS_API = "/api/v1/utilities/leader-board";
export const SUBMIT_SOCIAL_TRADING_PROVIDER_API =
  "/api/v1/providers";
export const SOCIAL_TRADING_PROVIDERS_OFFERS_API = `/api/v1/providers/${SocialTradingProviderIdParamValue}/offers`;
export const SUBMIT_SOCIAL_TRADING_PROVIDER_OFFER_API = `/api/v1/providers/offers`;
export const SOCIAL_TRADING_SUBSCRIPTIONS_API = `/api/v1/subscriptions`;
export const SOCIAL_TRADING_PROVIDERS_CONFIG_API = `/api/v1/providers/1/config`;
export const FETCH_SOCIAL_TRADING_PROVIDER_POSITIONS_API = `/api/v1/providers/${SocialTradingProviderIdParamValue}/positions`;
export const FETCH_SOCIAL_TRADING_PROVIDER_DETAILS_API = `/api/v1/providers/${SocialTradingProviderIdParamValue}`;
export const FETCH_SOCIAL_TRADING_HISTORY_DAILY_CHART_API = `/api/v1/history/daily-chart`;

// NEW APIS
export const UPDATE_SOCIAL_TRADING_PROVIDER_API =
  "/api/v1/providers";
export const FETCH_SOCIAL_TRADING_PROVIDER_METRICS_API = `/api/v1/providers/${SocialTradingProviderIdParamValue}/metrics`;
export const FETCH_SOCIAL_TRADING_PROVIDER_SUBSCRIPTIONS_API = `/api/v1/providers/${SocialTradingProviderIdParamValue}/subscriptions`;
export const FETCH_SOCIAL_TRADING_PROVIDER_DEALS_API = `/api/v1/providers/${SocialTradingProviderIdParamValue}/deals`;
export const FETCH_SOCIAL_TRADING_PROVIDER_PORTFOLIO_API =
  "/api/v1/providers/portfolio";

export const UPDATE_SOCIAL_TRADING_SUBSCRIPTION_API = `/api/v1/subscriptions`;
export const FETCH_SOCIAL_TRADING_SUBSCRIPTION_DETAILS_API = `/api/v1/subscriptions`;
export const FETCH_SOCIAL_TRADING_SUBSCRIPTION_DEALS_API = `/api/v1/subscriptions/${SocialTradingSubscriptionIdParamValue}/deals`;
export const FETCH_SOCIAL_TRADING_SUBSCRIPTION_METRICS_API = `/api/v1/subscriptions/${SocialTradingSubscriptionIdParamValue}/metrics`;
export const FETCH_SOCIAL_TRADING_SUBSCRIPTION_TRADING_RESULTS_API = `/api/v1/subscriptions/${SocialTradingSubscriptionIdParamValue}/trading-results`;
export const FETCH_SOCIAL_TRADING_SUBSCRIPTION_RISK_API = `/api/v1/subscriptions/${SocialTradingSubscriptionIdParamValue}/risk`;
export const UPDATE_SOCIAL_TRADING_SUBSCRIPTION_RISK_API = `/api/v1/subscriptions/${SocialTradingSubscriptionIdParamValue}/risk`;
export const DELETE_SOCIAL_TRADING_SUBSCRIPTION_API = `/api/v1/subscriptions`;

export const FETCH_SOCIAL_TRADING_FOLLOWER_PORTFOLIO_API = `/api/v1/followers/portfolio`;
export const FETCH_SOCIAL_TRADING_FOLLOWER_POSITIONS_API = `/api/v1/followers/${SocialTradingSubscriptionIdParamValue}/positions`;

export const FETCH_SOCIAL_TRADING_OFFER_DETAILS_API = `/api/v1/providers/offers/${SocialTradingOfferIdParamValue}/details`;
export const FETCH_SOCIAL_TRADING_FEES_API = "/api/v1/utilities/fees";
export const SUBSCRIBE_AGGREGATE_API = "/api/v1/utilities/subscriptions/aggregate";
export const SUBMIT_PROVIDER_APPLICATION_API = "/api/v1/providers/applications";
export const SUBMIT_PROVIDER_AGGREGATE_API = "/api/v1/utilities/providers/aggregate";

export const SocialTradingProfileIdParamValue = "{profileId}";
export const FETCH_SOCIAL_TRADING_RATE_PROFILE_API = `/api/v1/utilities/reports/rate-profile/${SocialTradingProfileIdParamValue}`;

export const SocialTradingAccountIdParamValue = "{accountId}";
export const FETCH_SOCIAL_TRADING_HISTORY_INDICATORS_API = `/api/v1/history/indicators/${SocialTradingAccountIdParamValue}`;
export const FETCH_SOCIAL_TRADING_INSTRUMENT_REPORT_API = `/api/v1/utilities/reports/providers/${SocialTradingAccountIdParamValue}/instrument-report`;
export const FETCH_SOCIAL_TRADING_TRADE_REPORT_API = `/api/v1/utilities/reports/trade/${SocialTradingAccountIdParamValue}`;
